import React, { useState, useReducer, useEffect } from 'react'
import * as yup from "yup"
import { Form, Formik } from 'formik';
import Modal from 'react-bootstrap/Modal';
import { formInitialState, formReducer } from '../../../../../reducers/formReducer';
import FormErrorMessage from '../../../../UI/errorMessages/FormErrorMessage';
import CMSFormTextArea from '../../../../UI/forms/CMSFormTextArea';
import { Alert, Button, Card, Col, Row } from 'react-bootstrap';
import axios from "../../../../../config/axios";
import { Store as toast } from 'react-notifications-component';
import { toastNotification } from '../../../../../config/toastNotification'
import CMSFormInput from '../../../../UI/forms/CMSFormInput';
import CMSFormCheckBoxes from '../../../../UI/forms/CMSFormCheckBoxes';
import { didCapacityReached, getFullName } from '../../../../../helpers/CommonHelper';
import ModuleDisplayDate from '../../../../UI/modules/fieldsDisplay/ModuleDisplayDate';

import CMSFormSwitch from '../../../../UI/forms/CMSFormSwitch';
import CMSFormSelect from '../../../../UI/forms/CMSFormSelect';
import { Link } from 'react-router-dom';


export const RegisterNewModal = ({ show, setShow, loadItems, id, members, activity }) => {
    const [formState, formDispatch] = useReducer(formReducer, formInitialState)

    const handleClose = (resetForm) => {
        resetForm();  // Reset form values
        setShow(false);
    };
    const handleShow = () => setShow(true);
    const calculateTotalValue = (values, item) => {
        let total = 0;

        if (item.paidActivity === "1") {
            total += item.participationFee; // Member fee
        }

        if (values.partnerParticipating === "1" && item.partnerFeaturesSettings?.paidParticipation === "1") {
            total += item.partnerFeaturesSettings.participationFee;
        }

        if (values.guestParticipating === "1" && item.guestFeaturesSettings?.paidParticipation === "1") {
            total += item.guestFeaturesSettings.participationFee * values.NumberOfGuestParticipating;
        }

        if (values.kidsParticipating === "1" && item.kidsFeaturesSettings?.paidParticipation === "1") {
            total += item.kidsFeaturesSettings.participationFee * values.NumberOfKidsParticipating;
        }

        return total;
    };
    const generateOptionsArray = (num) => {
        const parsedNum = Number(num);
        if (isNaN(parsedNum) || parsedNum < 1) {
            return [];
        }

        return Array.from({ length: Math.floor(parsedNum) }, (_, i) => ({
            label: `${i + 1}`,
            value: i + 1
        }));
    };

    const onSubmit = async (data, { resetForm }) => {

        formDispatch({
            type: "FORM_SUBMISSION_REQUEST"
        });

        try {
            const res = await axios.post(`activity-registrations/register`, data);
            formDispatch({
                type: "FORM_SUBMISSION_SUCCESS",
                payload: res.data
            });
            handleClose(resetForm)
            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `Action done successfully.`,
                type: "success",
            });
            resetForm();
            formDispatch({
                type: "FORM_INITIAL_STAGE"
            });
            loadItems()
        } catch (error) {
            formDispatch({
                type: "FORM_SUBMISSION_FAILED",
                payload: error
            });
            toast.addNotification({
                ...toastNotification,
                title: "Alert!",
                message: `Action failed, try again later.`,
                type: "danger",
            });
            setTimeout(() => {
                formDispatch({
                    type: "FORM_INITIAL_STAGE"
                });
            }, 5000)
        }
    }

    const getValidationSchema = () => {
        return yup.object({
            memberId: yup.string().required("Please select a member"),
            partnerParticipating: yup.string(),
            guestParticipating: yup.string(),
            kidsParticipating: yup.string(),
            NumberOfGuestParticipating: yup.string(),
            NumberOfKidsParticipating: yup.string(),

        })
    }

    const getInitialValues = () => {

        let returnObj = {
            memberId: '',
            activityId: id,
            partnerParticipating: "0",
            guestParticipating: "0",
            NumberOfGuestParticipating: 1,
            kidsParticipating: "0",
            NumberOfKidsParticipating: 1,
            adminNotes: ''
        }
        return returnObj;
    }
    const transformArray = (data) => {
        return [
            { label: "Select a member", value: "" }, // Placeholder option
            ...data.map(item => ({
                label: item.fullName,
                value: item._id
            }))
        ];
    };


    return (


        <>
            <>  {activity != null &&
                <Formik
                    initialValues={getInitialValues()}
                    validationSchema={getValidationSchema()}
                    enableReinitialize={true}
                    validateOnChange={true}
                    validateOnBlur={true}
                    onSubmit={async (values, { resetForm }) => {
                        if (values.guestParticipating === "0") {
                            values.NumberOfGuestParticipating = 0
                        }
                        if (values.kidsParticipating === "0") {
                            values.NumberOfKidsParticipating = 0
                        }
                        console.log(values);
                        onSubmit(values, { resetForm })
                    }}
                >
                    {(form) => (

                        <Modal className={((activity.guestFeaturesSettings?.allowed === "1" || activity.kidsFeaturesSettings.allowed === "1") && members && members.length > 0) ? 'acceptModal' : ""} show={show} onHide={() => handleClose(form.resetForm)}>
                            {(formState.isFormSubmitting) && <div class="overlay">
                                <i class="fas fa-2x fa-sync-alt text-white fa-spin"></i>
                            </div>}
                            {/* {(formState.isFormSubmitting) && <ContainerLoading />} */}

                            <Form onSubmit={form.handleSubmit}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Register</Modal.Title>
                                </Modal.Header>
                                {activity && members && members.length > 0 ?
                                    <>
                                        <Modal.Body className={didCapacityReached(activity) ? "p-1" : "p-2"}>
                                            {(formState.hasSubmissionError) &&
                                                <FormErrorMessage error={formState.formSubmissionError} />
                                            }
                                            <Row className='w-100 mx-auto mt-0'>
                                                {didCapacityReached(activity) && <>
                                                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className='mb-1'>
                                                        <div className="alertNotApplicable red fontItalic m-0  py-2">
                                                            Registrations reached maximum capacity.
                                                            <span>
                                                                <a href={`/activities/update/${id}`} className="increase-capacity-link">
                                                                    <span className="increase-capacity-text">
                                                                        Click to Increase Capacity
                                                                    </span>
                                                                </a>
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </>}
                                                <>
                                                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className=''>

                                                        {
                                                            ((activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.allowed === "0") ||
                                                                (activity.guestFeaturesSettings && activity.guestFeaturesSettings.allowed === "0") ||
                                                                (activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.allowed === "0")
                                                            ) && (
                                                                <div className="alertNotApplicable yellow fontItalic m-0 mb-3 py-3">
                                                                    {activity.paidActivity === "1" && activity.participationFee > 0 &&
                                                                        <p className='participationFeeDisplay top mb-1'>Participation fee for member is <b>{activity.participationFee} AED</b></p>}
                                                                    {activity.paidActivity === "0" &&
                                                                        <p className='participationFeeDisplay text-success top mb-2'>Participation is free for member</p>}
                                                                    {
                                                                        (activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.allowed === "0")
                                                                            ? <p className='mb-0 '>Partner participation is not allowed</p>

                                                                            : null
                                                                    }
                                                                    {
                                                                        (activity.guestFeaturesSettings && activity.guestFeaturesSettings.allowed === "0")
                                                                            ? <p className='mb-0 '>Guest participation is not allowed</p>

                                                                            : null
                                                                    }

                                                                    {
                                                                        (activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.allowed === "0")
                                                                            ? <p className='mb-0 '>Kids participation is not allowed.</p>

                                                                            : null
                                                                    }

                                                                </div>
                                                            )
                                                        }

                                                    </Col>
                                                    <Col xl={(activity.guestFeaturesSettings?.allowed === "1" || activity.kidsFeaturesSettings.allowed === "1") ? 6 : 12} lg={(activity.guestFeaturesSettings?.allowed === "1" || activity.kidsFeaturesSettings.allowed === "1") ? 6 : 12} md={12} sm={12} xs={12} className=''>
                                                        <div className='mt-1 px-3'>
                                                            {(activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.allowed === "1") &&
                                                                (activity.guestFeaturesSettings && activity.guestFeaturesSettings.allowed === "1") &&
                                                                (activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.allowed === "1")
                                                                && activity.paidActivity === "1" && activity.participationFee > 0 &&
                                                                <p className='participationFeeDisplay top mb-3'>Participation fee for member is <b>{activity.participationFee} AED</b></p>}
                                                            {(activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.allowed === "1") &&
                                                                (activity.guestFeaturesSettings && activity.guestFeaturesSettings.allowed === "1") &&
                                                                (activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.allowed === "1")
                                                                && activity.paidActivity === "0" &&
                                                                <p className='participationFeeDisplay text-success top mb-3'>Participation is free for member</p>}
                                                            <CMSFormSelect
                                                                name="memberId"
                                                                label="Select Member"
                                                                required={true}
                                                                form={form}
                                                                options={transformArray(members)}
                                                            />


                                                            {
                                                                (activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.allowed === "1")
                                                                    ? <div className={activity.guestFeaturesSettings?.allowed === "1" || activity.kidsFeaturesSettings.allowed === "1" ? ' pt-0' : "pt-0"}>
                                                                        <CMSFormSwitch
                                                                            name="partnerParticipating"
                                                                            label="Partner Participating?"
                                                                            initialValue={(getInitialValues().partnerParticipating === "1") ? true : false}
                                                                            onChange={(value) => form.setFieldValue("partnerParticipating", value ? "1" : "0")}

                                                                        />
                                                                        {activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.paidParticipation === "1" &&
                                                                            <p className='participationFeeDisplay mb-3'>Participation fee for partner is <b>{activity.partnerFeaturesSettings.participationFee} AED</b></p>}
                                                                        {activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.paidParticipation === "0" &&
                                                                            <p className='participationFeeDisplay text-success mb-3'>Participation is free for partner</p>}
                                                                    </div>
                                                                    : null
                                                            }
                                                            <CMSFormTextArea
                                                                name="notes"
                                                                label="Notes For Admin Records"
                                                                form={form}
                                                                required={false}
                                                            />
                                                        </div>

                                                    </Col>
                                                    {(activity.guestFeaturesSettings?.allowed === "1" || activity.kidsFeaturesSettings.allowed === "1") &&
                                                        <Col xl={6}>
                                                            <div className='mt-1 px-3'>
                                                                {
                                                                    (activity.guestFeaturesSettings && activity.guestFeaturesSettings.allowed === "1")
                                                                        ? <div className={activity.kidsFeaturesSettings.allowed === "1" ? ' pt-2' : "pt-0"}> <CMSFormSwitch
                                                                            name="guestParticipating"
                                                                            label="Guest Participating?"
                                                                            onChange={(value) => form.setFieldValue("guestParticipating", value ? "1" : "0")}
                                                                            initialValue={(getInitialValues().guestParticipating === "1") ? true : false}

                                                                        />
                                                                            {activity.guestFeaturesSettings && activity.guestFeaturesSettings.paidParticipation === "1" &&
                                                                                <p className='participationFeeDisplay mb-3'> Participation fee per guest is <b>{activity.guestFeaturesSettings.participationFee} AED</b></p>}
                                                                            {activity.guestFeaturesSettings && activity.guestFeaturesSettings.paidParticipation === "0" &&
                                                                                <p className='participationFeeDisplay  text-success mb-3'> Participation is free for guest(s)</p>}
                                                                            {(form.values.guestParticipating === "1" || form.values.guestParticipating === true) &&
                                                                                <CMSFormSelect
                                                                                    name="NumberOfGuestParticipating"
                                                                                    label="Number Of Guest Participating"
                                                                                    required={true}
                                                                                    form={form}
                                                                                    options={generateOptionsArray(activity.guestFeaturesSettings.allowedNumbers)}
                                                                                />}
                                                                        </div>
                                                                        : null
                                                                }
                                                                {
                                                                    (activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.allowed === "1")
                                                                        ? <div className="pt-2"> <CMSFormSwitch
                                                                            name="kidsParticipating"
                                                                            label="Kids Participating?"
                                                                            initialValue={(getInitialValues().kidsParticipating === "1") ? true : false}
                                                                            onChange={(value) => form.setFieldValue("kidsParticipating", value ? "1" : "0")}
                                                                        />
                                                                            {activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.paidParticipation === "1" &&
                                                                                <p className='participationFeeDisplay mb-3'>Participation fee per kid is <b>{activity.kidsFeaturesSettings.participationFee} AED</b></p>}
                                                                            {activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.paidParticipation === "0" &&
                                                                                <p className='participationFeeDisplay text-success mb-3'>Participation is free for kid(s)</p>}
                                                                            {(form.values.kidsParticipating === "1" || form.values.kidsParticipating === true) &&
                                                                                <CMSFormSelect
                                                                                    name="NumberOfKidsParticipating"
                                                                                    label="Number Of Kids Participating"
                                                                                    required={true}
                                                                                    form={form}
                                                                                    options={generateOptionsArray(activity.kidsFeaturesSettings.allowedNumbers)}
                                                                                />}
                                                                        </div>
                                                                        : null
                                                                }
                                                            </div>
                                                        </Col>}
                                                    {/* {(activity.partnerFeaturesSettings?.allowed === "1" || activity.guestFeaturesSettings?.allowed === "1" || activity.kidsFeaturesSettings.allowed === "1") &&
                                                        <Col xl={(activity.guestFeaturesSettings?.allowed === "0" && activity.kidsFeaturesSettings.allowed === "0") ? 12 : 5}
                                                            lg={(activity.guestFeaturesSettings?.allowed === "0" && activity.kidsFeaturesSettings.allowed === "0") ? 12 : 5}
                                                            md={(activity.guestFeaturesSettings?.allowed === "0" && activity.kidsFeaturesSettings.allowed === "0") ? 12 : 5}
                                                            sm={(activity.guestFeaturesSettings?.allowed === "0" && activity.kidsFeaturesSettings.allowed === "0") ? 12 : 12}
                                                            xs={12}
                                                            className='d-flex flex-column justify-content-start me-4 '>

                                                            <div className='mt-2'>
                                                              
                                                                {(activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.allowed === "1") &&
                                                                    (activity.guestFeaturesSettings && activity.guestFeaturesSettings.allowed === "1") &&
                                                                    (activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.allowed === "1")
                                                                    && activity.paidActivity === "1" && activity.participationFee > 0 &&
                                                                    <p className='participationFeeDisplay top mb-2'>Participation fee for member is <b>{activity.participationFee} AED</b></p>}
                                                                {(activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.allowed === "1") &&
                                                                    (activity.guestFeaturesSettings && activity.guestFeaturesSettings.allowed === "1") &&
                                                                    (activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.allowed === "1")
                                                                    && activity.paidActivity === "0" &&
                                                                    <p className='participationFeeDisplay text-success top mb-2'>Participation is free for member</p>}

                                                                {
                                                                    (activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.allowed === "1")
                                                                        ? <div className={activity.guestFeaturesSettings?.allowed === "1" || activity.kidsFeaturesSettings.allowed === "1" ? 'border-bottom pt-0' : "pt-0"}>
                                                                            <CMSFormSwitch
                                                                                name="partnerParticipating"
                                                                                label="Partner Participating?"
                                                                                initialValue={(getInitialValues().partnerParticipating === "1") ? true : false}
                                                                                onChange={(value) => form.setFieldValue("partnerParticipating", value ? "1" : "0")}

                                                                            />
                                                                            {activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.paidParticipation === "1" &&
                                                                                <p className='participationFeeDisplay mb-3'>Participation fee for partner is <b>{activity.partnerFeaturesSettings.participationFee} AED</b></p>}
                                                                            {activity.partnerFeaturesSettings && activity.partnerFeaturesSettings.paidParticipation === "0" &&
                                                                                <p className='participationFeeDisplay text-success mb-3'>Participation is free for partner</p>}
                                                                        </div>
                                                                        : null
                                                                }
                                                                {
                                                                    (activity.guestFeaturesSettings && activity.guestFeaturesSettings.allowed === "1")
                                                                        ? <div className={activity.kidsFeaturesSettings.allowed === "1" ? 'border-bottom pt-2' : "pt-0"}> <CMSFormSwitch
                                                                            name="guestParticipating"
                                                                            label="Guest Participating?"
                                                                            onChange={(value) => form.setFieldValue("guestParticipating", value ? "1" : "0")}
                                                                            initialValue={(getInitialValues().guestParticipating === "1") ? true : false}

                                                                        />
                                                                            {activity.guestFeaturesSettings && activity.guestFeaturesSettings.paidParticipation === "1" &&
                                                                                <p className='participationFeeDisplay mb-3'> Participation fee per guest is <b>{activity.guestFeaturesSettings.participationFee} AED</b></p>}
                                                                            {activity.guestFeaturesSettings && activity.guestFeaturesSettings.paidParticipation === "0" &&
                                                                                <p className='participationFeeDisplay  text-success mb-3'> Participation is free for guest(s)</p>}
                                                                            {(form.values.guestParticipating === "1" || form.values.guestParticipating === true) &&
                                                                                <CMSFormSelect
                                                                                    name="NumberOfGuestParticipating"
                                                                                    label="Number Of Guest Participating"
                                                                                    required={true}
                                                                                    form={form}
                                                                                    options={generateOptionsArray(activity.guestFeaturesSettings.allowedNumbers)}
                                                                                />}
                                                                        </div>
                                                                        : null
                                                                }
                                                                {
                                                                    (activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.allowed === "1")
                                                                        ? <div className="pt-2"> <CMSFormSwitch
                                                                            name="kidsParticipating"
                                                                            label="Kids Participating?"
                                                                            initialValue={(getInitialValues().kidsParticipating === "1") ? true : false}
                                                                            onChange={(value) => form.setFieldValue("kidsParticipating", value ? "1" : "0")}
                                                                        />
                                                                            {activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.paidParticipation === "1" &&
                                                                                <p className='participationFeeDisplay mb-3'>Participation fee per kid is <b>{activity.kidsFeaturesSettings.participationFee} AED</b></p>}
                                                                            {activity.kidsFeaturesSettings && activity.kidsFeaturesSettings.paidParticipation === "0" &&
                                                                                <p className='participationFeeDisplay text-success mb-3'>Participation is free for kid(s)</p>}
                                                                            {(form.values.kidsParticipating === "1" || form.values.kidsParticipating === true) &&
                                                                                <CMSFormSelect
                                                                                    name="NumberOfKidsParticipating"
                                                                                    label="Number Of Kids Participating"
                                                                                    required={true}
                                                                                    form={form}
                                                                                    options={generateOptionsArray(activity.kidsFeaturesSettings.allowedNumbers)}
                                                                                />}
                                                                        </div>
                                                                        : null
                                                                }
                                                            </div>
                                                        </Col>} */}

                                                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className='border-top pt-3 mt-2 mb-2'>
                                                        <div className='d-flex align-items-center justify-content-end totalAmountDisplay'>
                                                            <p className='d-flex mb-0'>Total Amount: <h5 className='mb-0 mx-2'>{calculateTotalValue(form.values, activity)} AED</h5></p>
                                                        </div>
                                                    </Col>
                                                </>
                                            </Row>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={() => handleClose(form.resetForm)}>
                                                Close
                                            </Button>
                                            <Button variant="primary" type="submit">
                                                Submit
                                            </Button>
                                        </Modal.Footer>
                                    </> : <Alert className='m-1' variant='danger'>All members are enrolled in the activity.</Alert>}

                            </Form>


                        </Modal>

                    )}
                </Formik>
            }</>



        </>

    )
}
